import type { SvgPathProps } from '../Icon';

const Female: React.FC<SvgPathProps> = ({ isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <path d="M23.668 29.037c-5.992 0-10.867-4.875-10.867-10.868s4.875-10.87 10.867-10.87c5.993 0 10.868 4.877 10.868 10.87 0 5.993-4.875 10.868-10.868 10.868m12.169-10.868c0-6.71-5.459-12.17-12.169-12.17C16.959 6 11.5 11.46 11.5 18.17c0 6.49 5.111 11.794 11.518 12.135v4.759H18.51v1.3h4.508v5.376h1.3v-5.376h4.508v-1.3h-4.508v-4.76c6.408-.34 11.519-5.644 11.519-12.134" />
  );

  const normalHover = (
    <path d="M12.801 15.968c0-5.993 4.875-10.869 10.868-10.869s10.868 4.876 10.868 10.869c0 5.993-4.875 10.868-10.868 10.868s-10.868-4.875-10.868-10.868m23.037 0c0-6.71-5.459-12.168-12.169-12.168-6.71 0-12.169 5.458-12.169 12.168 0 6.49 5.112 11.794 11.519 12.135v6.968h-4.508v1.299h4.508v5.376h1.301V36.37h4.507v-1.299H24.32v-6.968c6.406-.341 11.518-5.645 11.518-12.135" />
  );

  return isHovered ? normalHover : normal;
};

export default Female;
